<template>
    <!-- 결제정보 자동 등록 팝업 -->
    <div v-show='show' class='layer-pop square-type'>
        <div class='view-content' style='width: 800px;'>
            <button class='close' @click='onClosePop'><span class='blind'>팝업 닫기</span></button>
            <div class="com-tab" style='margin-top: 0; border-bottom: none'>
              <span v-for="(item, index) in submenus" :key="index">
                  <p class='sub-title px-6 ' :class="{ 'sub-title-on': submenuIndex === index }" style='cursor: pointer' @click='onCancelTab(index)'>{{ item.label }}</p>
              </span>
            </div>
            <div class='px-6'>
              <div class='com-table-wrap mt-3'>
                <table class='com-table'>
                  <colgroup>
                      <col style='width:120px'>
                      <col style='width:auto'>
                      <col style='width:120px'>
                      <col style='width:auto'>
                  </colgroup>
                  <tbody>
                    <tr>
                      <th>회원명</th>
                      <td colspan="3" class="text-left">{{ data.nt_member_nm || '' }}</td>
                    </tr>
                    <tr>
                      <th>이용권 명</th>
                      <td class="text-left">{{ data.nt_ticket_nm || '' }}</td>
                      <th>사용 횟수</th>
                      <td class="text-left">
                        <span v-if="data.less_cnt_type_cd === 'U'"> <!--무제한인 경우-->
                            {{ Number(data.less_join_cnt || 0) + Number(data.less_absn_cnt || 0) }}/무제한
                        </span>
                        <span v-if="data.less_cnt_type_cd === 'T'"> 
                            총 {{ Number(data.less_join_cnt || 0) + Number(data.less_absn_cnt || 0) }}/{{ data.less_total_cnt }}회
                        </span>
                        <span v-if="data.less_cnt_type_cd === 'W'"> 
                            {{ Number(data.less_join_cnt || 0) + Number(data.less_absn_cnt || 0) }}/주 {{ data.less_total_cnt }}회
                        </span>
                      </td>
                    </tr>
                    <tr>
                      <th>결제 수단</th>
                      <td class="text-left">
                        <template v-if="!!data.nt_fn_cd">
                          <p>
                            {{ data.nt_fn_cd ? cardTypes[data.nt_fn_cd] : '' }} 
                            <span v-if="!!data.nt_install_mnt">
                              ({{ data.nt_install_mnt === '00' ? '일시불' : `${Number(data.nt_install_mnt)}개월` }})
                            </span>
                          </p>
                          <p>{{ (data.nt_payment_no || '') | cardNumberFilter }}</p>
                        </template>
                      </td>
                      <th>결제 금액</th>
                      <td class="text-left">
                        {{ (data.nt_goods_amt || 0) | numberFormatFilter }}원
                      </td>
                    </tr>
                    <tr v-show="submenuIndex === 1">
                      <th></th>
                      <td class="text-left">
                      </td>
                      <th>취소 금액</th>
                      <td class="text-left">
                        <input v-model="subCancelAmount" type="number" placeholder="취소 금액을 입력해 주세요."
                               :max="parseInt(data.nt_goods_amt)"
                               @input="checkMaxValue"
                                >
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="description">
                {{ submenuIndex === 0 ? '결제한 수단으로 총 결제금액이 취소됩니다.' : '결제한 수단으로 입력한 금액이 취소됩니다.' }}
              </div>
              
              <div class='bottom-btn mt-8'>
                  <button class='com-btn' @click='onClosePop'>취소</button>
                  <button class='com-btn blue' @click='handleSubmit'>취소요청</button>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import { NICEPAY_CARDS } from '@/assets/js/common';

export default {
  name: 'PaymentCancelDlg',
  props: {
    show: Boolean,
    data: Object,
    close: Function,
    confirm: Function
  },
  data() {
    return {
      cardTypes: NICEPAY_CARDS,
      submenus: [
        { name: 'AllCancelPayment', label: '결제취소' },
        { name: 'SubCancelPayment', label: '분할취소' },
      ],
      submenuIndex : 0,
      subCancelAmount : 0,
    };
  },
  computed: {
    centerId() {
      return this.$store.getters['auth/cId'];
    },
  },
  methods: {
    onClosePop() {
      this.close();
    },

    handleSubmit() {
      this.confirm(this.submenuIndex === 0 ? this.data.nt_goods_amt : this.subCancelAmount)
    },

    onCancelTab(index) {
      console.log("센터 아이디 = ", this.centerId)
      if(index === 1 && this.centerId !== "80") {
        return
      }
      this.submenuIndex = index;
    },

    checkMaxValue() {
      if (this.subCancelAmount > this.data.nt_goods_amt) {
        this.subCancelAmount = this.data.nt_goods_amt; // 최대값을 초과하면 maxValue로 설정
      }
    }
  },
};
</script>
<style scoped>
  .description{
    background-color: #F1F5F7;
    text-align: center;
    padding: 10px;
    margin-top: 14px;
    color: #808080;
  }
</style>
